<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.75 22C18.2728 22 22.75 17.5228 22.75 12C22.75 6.47715 18.2728 2 12.75 2C7.22715 2 2.75 6.47715 2.75 12C2.75 17.5228 7.22715 22 12.75 22Z"
      fill='white' fill-opacity="0.5" />
    <path
      d="M11.3295 15.58C11.1295 15.58 10.9395 15.5 10.7995 15.36L7.96945 12.53C7.67945 12.24 7.67945 11.76 7.96945 11.47C8.25945 11.18 8.73945 11.18 9.02945 11.47L11.3295 13.77L16.4695 8.62998C16.7595 8.33998 17.2395 8.33998 17.5295 8.62998C17.8195 8.91998 17.8195 9.39998 17.5295 9.68998L11.8595 15.36C11.7195 15.5 11.5295 15.58 11.3295 15.58Z"
      fill='white' fill-opacity="1" />
  </svg>
</template>